var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.6667 18.3334C11.6667 18.3334 12.3744 18.2323 15.3033 15.3034C18.2322 12.3744 18.2322 7.62571 15.3033 4.69678C14.2656 3.65905 12.9994 2.98899 11.6667 2.6866M11.6667 18.3334H16.6667M11.6667 18.3334L11.6667 13.3334M8.33333 1.66691C8.33333 1.66691 7.62563 1.76801 4.6967 4.69694C1.76777 7.62588 1.76777 12.3746 4.6967 15.3035C5.73443 16.3413 7.0006 17.0113 8.33333 17.3137M8.33333 1.66691L3.33333 1.66675M8.33333 1.66691L8.33333 6.66675",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.d3e663ec11a0e8a95e26fea14cefe5fd.svg";
export { ForwardRef as ReactComponent };